import React from 'react';
import { Textarea as HeroTextarea } from '@heroui/react';

interface TextareaProps {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  variant?: 'bordered' | 'underlined' | 'flat' | 'faded';
  className?: string;
  description?: string;
  errorMessage?: string;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  fullWidth?: boolean;
  minRows?: number;
  maxRows?: number;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  placeholder,
  value = '',
  onChange,
  isRequired = false,
  isDisabled = false,
  isReadOnly = false,
  size = 'md',
  color = 'default',
  variant = 'bordered',
  className = '',
  description,
  errorMessage,
  startContent,
  endContent,
  radius = 'md',
  fullWidth = false,
  minRows = 3,
  maxRows = 8,
}) => {
  return (
    <div className={`flex flex-col gap-2 ${fullWidth ? 'w-full' : ''} ${className}`}>
      <HeroTextarea
        label={label}
        placeholder={placeholder}
        labelPlacement="outside"
        value={value}
        onValueChange={onChange}
        isRequired={isRequired}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        size={size}
        color={color}
        variant={variant}
        description={description}
        errorMessage={errorMessage}
        startContent={startContent}
        endContent={endContent}
        radius={radius}
        fullWidth={fullWidth}
        minRows={minRows}
        maxRows={maxRows}
        classNames={{
          base: 'min-h-[10rem]',
          input: 'text-sm !h-[10rem] text-auth-ink leading-5',
          inputWrapper: 'rounded-2',
          label: 'text-sm font-medium text-auth-ink',
          description: 'text-xs text-auth-muted',
          errorMessage: 'text-xs text-auth-strength-weak',
        }}
      />
    </div>
  );
};
